'use strict';

module.exports = require('./is-implemented')()
	? String.prototype.contains
	: require('./shim');



//////////////////
// WEBPACK FOOTER
// ./~/event-emitter/~/es5-ext/string/#/contains/index.js
// module id = 26
// module chunks = 0